// extracted by mini-css-extract-plugin
module.exports = {"legendContainer":"styles_legendContainer__3fFVO","legendItem":"styles_legendItem__1icch","colorBox":"styles_colorBox__2fSvR"};